// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LandingModalBase_wrapper__Jc1Fp","closeIcon":"LandingModalBase_closeIcon__wqO8B","button":"LandingModalBase_button__uDQtE"};